// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Photos__row":"sl_a bha_a bha_r bha_j","Photos__img":"sl_b bha_b"};